<template>
  <div class="admin-header">
    <h1>管理控制台</h1>
    <nav class="nav-menu">
      <router-link to="/admin" class="nav-link" exact>仪表盘</router-link>
      <router-link to="/admin/config" class="nav-link">配置管理</router-link>
      <router-link to="/admin/cards" class="nav-link">卡密管理</router-link>
      <router-link to="/admin/announcements" class="nav-link">公告管理</router-link>
      <router-link to="/admin/export" class="nav-link">导出管理</router-link>
      <button @click="$emit('logout')" class="btn btn-danger btn-sm logout-btn">
        登出
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'AdminHeader',
  emits: ['logout']
}
</script>

<style scoped>
.admin-header {
  margin-bottom: var(--spacing-xxl);
}

.admin-header h1 {
  color: var(--text-primary);
  margin-bottom: var(--spacing-xl);
  font-size: var(--font-size-xxxl);
  font-weight: 600;
  margin-top: 0;
}

.nav-menu {
  display: flex;
  gap: var(--spacing-xl);
  border-bottom: 2px solid var(--border-color);
  padding-bottom: var(--spacing-sm);
  align-items: center;
  flex-wrap: wrap;
}

.nav-link {
  padding: var(--spacing-sm) var(--spacing-lg);
  text-decoration: none;
  color: var(--text-secondary);
  border-radius: var(--border-radius-sm);
  transition: all var(--transition-normal);
  font-weight: 500;
  font-size: var(--font-size-md);
}

.nav-link:hover,
.nav-link.router-link-active {
  background-color: var(--primary-color);
  color: white;
}

.logout-btn {
  margin-left: auto;
}

@media (max-width: 768px) {
  .nav-menu {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-sm);
  }

  .logout-btn {
    margin-left: 0;
    align-self: flex-end;
  }
}
</style>